"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _Option = _interopRequireDefault(require("./Option"));
var _type = require("./type");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/DropDown.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_12zt8ampew() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/DropDown.js";
  var hash = "0eabe3e130276f762c21af6f4b4dfe32482150e7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/DropDown.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 30
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "2": {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "3": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 45
        }
      },
      "4": {
        start: {
          line: 73,
          column: 23
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "5": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 76,
          column: 3
        }
      },
      "6": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 67
        }
      },
      "7": {
        start: {
          line: 75,
          column: 38
        },
        end: {
          line: 75,
          column: 65
        }
      },
      "8": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 77,
          column: 15
        }
      },
      "9": {
        start: {
          line: 80,
          column: 22
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "10": {
        start: {
          line: 82,
          column: 19
        },
        end: {
          line: 82,
          column: 70
        }
      },
      "11": {
        start: {
          line: 82,
          column: 43
        },
        end: {
          line: 82,
          column: 69
        }
      },
      "12": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "13": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "14": {
        start: {
          line: 85,
          column: 23
        },
        end: {
          line: 85,
          column: 60
        }
      },
      "15": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 96,
          column: 8
        }
      },
      "16": {
        start: {
          line: 92,
          column: 30
        },
        end: {
          line: 92,
          column: 51
        }
      },
      "17": {
        start: {
          line: 97,
          column: 11
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "18": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 115,
          column: 8
        }
      },
      "19": {
        start: {
          line: 101,
          column: 27
        },
        end: {
          line: 101,
          column: 63
        }
      },
      "20": {
        start: {
          line: 102,
          column: 10
        },
        end: {
          line: 113,
          column: 12
        }
      },
      "21": {
        start: {
          line: 109,
          column: 38
        },
        end: {
          line: 109,
          column: 63
        }
      },
      "22": {
        start: {
          line: 116,
          column: 11
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "23": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 126,
          column: 8
        }
      },
      "24": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 16
        }
      },
      "25": {
        start: {
          line: 134,
          column: 17
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "26": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 141,
          column: 13
        }
      },
      "27": {
        start: {
          line: 144,
          column: 0
        },
        end: {
          line: 179,
          column: 2
        }
      },
      "28": {
        start: {
          line: 181,
          column: 0
        },
        end: {
          line: 186,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 17
          }
        },
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 45
          }
        },
        line: 60
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 73,
            column: 23
          },
          end: {
            line: 73,
            column: 24
          }
        },
        loc: {
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 73
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 75,
            column: 30
          },
          end: {
            line: 75,
            column: 31
          }
        },
        loc: {
          start: {
            line: 75,
            column: 38
          },
          end: {
            line: 75,
            column: 65
          }
        },
        line: 75
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 80,
            column: 22
          },
          end: {
            line: 80,
            column: 23
          }
        },
        loc: {
          start: {
            line: 80,
            column: 95
          },
          end: {
            line: 130,
            column: 1
          }
        },
        line: 80
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 82,
            column: 32
          },
          end: {
            line: 82,
            column: 33
          }
        },
        loc: {
          start: {
            line: 82,
            column: 43
          },
          end: {
            line: 82,
            column: 69
          }
        },
        line: 82
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 83,
            column: 21
          },
          end: {
            line: 83,
            column: 22
          }
        },
        loc: {
          start: {
            line: 83,
            column: 31
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 83
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 23
          }
        },
        loc: {
          start: {
            line: 92,
            column: 30
          },
          end: {
            line: 92,
            column: 51
          }
        },
        line: 92
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 100,
            column: 27
          },
          end: {
            line: 100,
            column: 28
          }
        },
        loc: {
          start: {
            line: 100,
            column: 36
          },
          end: {
            line: 114,
            column: 9
          }
        },
        line: 100
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 109,
            column: 26
          },
          end: {
            line: 109,
            column: 27
          }
        },
        loc: {
          start: {
            line: 109,
            column: 38
          },
          end: {
            line: 109,
            column: 63
          }
        },
        line: 109
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 122,
            column: 22
          },
          end: {
            line: 122,
            column: 23
          }
        },
        loc: {
          start: {
            line: 122,
            column: 28
          },
          end: {
            line: 122,
            column: 30
          }
        },
        line: 122
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 134,
            column: 18
          }
        },
        loc: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 141,
            column: 13
          }
        },
        line: 135
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 49
          }
        }, {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 45
          }
        }],
        line: 60
      },
      "1": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 74
      },
      "2": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 127,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 127,
            column: 5
          }
        }, {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }],
        line: 84
      },
      "3": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 34
          }
        }, {
          start: {
            line: 84,
            column: 38
          },
          end: {
            line: 84,
            column: 68
          }
        }],
        line: 84
      },
      "4": {
        loc: {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }],
        line: 97
      },
      "5": {
        loc: {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 127,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 116
      },
      "6": {
        loc: {
          start: {
            line: 136,
            column: 5
          },
          end: {
            line: 140,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 77
          }
        }, {
          start: {
            line: 139,
            column: 6
          },
          end: {
            line: 139,
            column: 53
          }
        }],
        line: 136
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0eabe3e130276f762c21af6f4b4dfe32482150e7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12zt8ampew = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12zt8ampew();
var Container = (cov_12zt8ampew().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-DropDown-Container"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      left: 0;\n      top: 52px;\n      z-index: 9999;\n      max-height: 240px;\n      overflow-y: auto;\n      white-space: nowrap;\n      border: 1px solid ", ";\n    "])), _stylingConstants.default.color.disabledText)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      left: 0;\n      top: 52px;\n      z-index: 9999;\n      max-height: 240px;\n      overflow-y: auto;\n      white-space: nowrap;\n      background-color: ", ";\n      border: ", ";\n      border-radius: var(--generalBorderRadius, 12px);\n      box-shadow: ", ";\n    "])), _themeMapper.evolutionTheme.dropdown.bgColor, _themeMapper.evolutionTheme.dropdown.border, _themeMapper.evolutionTheme.dropdown.boxShadow))));
var IconDropdownContainer = (cov_12zt8ampew().s[1]++, (0, _styledComponents.default)(Container)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: fit-content;\n  top: 20px;\n  left: -165px;\n  border-radius: 5px;\n  max-height: 10rem;\n  min-width: 190px;\n"]))));
var Title = (cov_12zt8ampew().s[2]++, _styledComponents.default.span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  font-size: 14px;\n  text-transform: uppercase;\n  padding: ", ";\n  font-weight: 500;\n  background: ", ";\n  &:hover {\n    cursor: default;\n  }\n"])), _stylingConstants.default.spacing.medium, function (props) {
  cov_12zt8ampew().f[0]++;
  cov_12zt8ampew().s[3]++;
  return props.isActive ? (cov_12zt8ampew().b[0][0]++, _stylingConstants.default.color.disabledBackground) : (cov_12zt8ampew().b[0][1]++, _stylingConstants.default.color.baseBackground);
}));

/**
 * Check if the option is inside of selectedItems
 * @param {object} option, value of the option to check
 * @param {object} selectedItems , items selected by the user
 */
cov_12zt8ampew().s[4]++;
var isActiveOption = function isActiveOption(option, selectedItems) {
  cov_12zt8ampew().f[1]++;
  cov_12zt8ampew().s[5]++;
  if (selectedItems) {
    cov_12zt8ampew().b[1][0]++;
    cov_12zt8ampew().s[6]++;
    return selectedItems.some(function (item) {
      cov_12zt8ampew().f[2]++;
      cov_12zt8ampew().s[7]++;
      return item.value === option.value;
    });
  } else {
    cov_12zt8ampew().b[1][1]++;
  }
  cov_12zt8ampew().s[8]++;
  return false;
};
cov_12zt8ampew().s[9]++;
var renderOptions = function renderOptions(_ref) {
  var options = _ref.options,
    onSelectedValue = _ref.onSelectedValue,
    single = _ref.single,
    selectedItems = _ref.selectedItems,
    isIconDropdown = _ref.isIconDropdown;
  cov_12zt8ampew().f[3]++;
  // If one option has icon, then show icon for all options
  var showIcon = (cov_12zt8ampew().s[10]++, options.some(function (element) {
    cov_12zt8ampew().f[4]++;
    cov_12zt8ampew().s[11]++;
    return element.icon !== undefined;
  }));
  cov_12zt8ampew().s[12]++;
  return options.map(function (option) {
    cov_12zt8ampew().f[5]++;
    cov_12zt8ampew().s[13]++;
    if ((cov_12zt8ampew().b[3][0]++, option.value !== undefined) && (cov_12zt8ampew().b[3][1]++, option.value.toString().length)) {
      cov_12zt8ampew().b[2][0]++;
      var isActive = (cov_12zt8ampew().s[14]++, isActiveOption(option, selectedItems));
      cov_12zt8ampew().s[15]++;
      return /*#__PURE__*/_react.default.createElement(_Option.default, {
        key: option.value,
        showIcon: showIcon,
        single: single,
        active: isActive,
        onSelected: function onSelected(item) {
          cov_12zt8ampew().f[6]++;
          cov_12zt8ampew().s[16]++;
          return onSelectedValue(item);
        },
        value: option,
        isIconDropdown: isIconDropdown,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 9
        }
      });
    } else {
      cov_12zt8ampew().b[2][1]++;
      cov_12zt8ampew().s[17]++;
      if (option.options) {
        cov_12zt8ampew().b[4][0]++;
        cov_12zt8ampew().s[18]++;
        return [/*#__PURE__*/_react.default.createElement(Title, {
          key: option.label,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 9
          }
        }, option.label), option.options.map(function (group) {
          cov_12zt8ampew().f[7]++;
          var isActive = (cov_12zt8ampew().s[19]++, isActiveOption(group, selectedItems));
          cov_12zt8ampew().s[20]++;
          return /*#__PURE__*/_react.default.createElement(_Option.default, {
            indentated: true,
            showIcon: showIcon,
            single: single,
            active: isActive,
            key: group.value,
            onSelected: function onSelected(selected) {
              cov_12zt8ampew().f[8]++;
              cov_12zt8ampew().s[21]++;
              return onSelectedValue(selected);
            },
            value: group,
            isIconDropdown: isIconDropdown,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 103,
              columnNumber: 13
            }
          });
        })];
      } else {
        cov_12zt8ampew().b[4][1]++;
        cov_12zt8ampew().s[22]++;
        if (option.label) {
          cov_12zt8ampew().b[5][0]++;
          cov_12zt8ampew().s[23]++;
          return /*#__PURE__*/_react.default.createElement(_Option.default, {
            showIcon: false,
            single: true,
            active: false,
            onSelected: function onSelected() {
              cov_12zt8ampew().f[9]++;
            },
            value: option,
            isIconDropdown: isIconDropdown,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 118,
              columnNumber: 9
            }
          });
        } else {
          cov_12zt8ampew().b[5][1]++;
        }
      }
    }
    cov_12zt8ampew().s[24]++;
    return null;
  });
};
/**
 * Container of options values
 */
cov_12zt8ampew().s[25]++;
var DropDown = function DropDown(props) {
  cov_12zt8ampew().f[10]++;
  cov_12zt8ampew().s[26]++;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 3
    }
  }, props.isIconDropdown ? (cov_12zt8ampew().b[6][0]++, /*#__PURE__*/_react.default.createElement(IconDropdownContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 7
    }
  }, " ", renderOptions(props), " ")) : (cov_12zt8ampew().b[6][1]++, /*#__PURE__*/_react.default.createElement(Container, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 7
    }
  }, " ", renderOptions(props), " ")));
};
cov_12zt8ampew().s[27]++;
DropDown.propTypes = {
  /**
   * List of options to show. The structure has two types:
   *
   * Show a simple label
   *   {
   *      label: Display the option label
   *      value: Value of option label
   *      icon: Source of the icon to show
   *   }
   *
   * Show a group option
   *   {
   *      label: Display the option label
   *      options: Array with values to group
   *   }
   */
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_type.SingleOptionType, _type.MultipleOptionType])).isRequired,
  /**
   * Method to be called when a option has been clicked
   */
  onSelectedValue: _propTypes.default.func.isRequired,
  /**
   * Array with values selected by the user
   */
  selectedItems: _propTypes.default.arrayOf(_type.SingleOptionType),
  /**
   * Indicate if accept single selection
   */
  single: _propTypes.default.bool,
  /*
  * Boolean to check what to display - an icon dropdown or normal select dropdown.
  */
  isIconDropdown: _propTypes.default.bool
};
cov_12zt8ampew().s[28]++;
DropDown.defaultProps = {
  options: [],
  single: false,
  selectedItems: [],
  isIconDropdown: false
};
var _default = exports.default = DropDown;